import { FunctionComponent } from 'react';
import Loader from '@app/components/Loader';
import { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariant } from '../../hook/__generated__/PricingPageShopProduct';
import BaseProductMessage from './BaseProductMessage';
import useUpgradePaths from '../../hook/useUpgradePaths';
import QualifiesForVariantMessage from './QualifiesForVariantMessage';
import QualifiesForUpdateMessage from './QualifiesForUpdateMessage';

const AuthenticatedUserUpgradeMessage: FunctionComponent<{
  selectedVariant: MagentoProductVariant | null;
  selectVariant: (value: MagentoProductVariant) => void;
  variants: Array<MagentoProductVariant | null> | null;
}> = ({ selectedVariant, selectVariant, variants }) => {
  const {
    upgradePaths,
    upgradeVariants,
    customerEmail,
    loading,
    error,
  } = useUpgradePaths();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    throw new Error('Unable to query the upgrade paths');
  }

  if (!upgradePaths) {
    return null;
  }

  const sdbsId = selectedVariant?.product?.sdbsId;
  const matchingUpgrade = sdbsId && upgradeVariants?.[sdbsId];

  if (matchingUpgrade) {
    return <QualifiesForVariantMessage matchingUpgrade={matchingUpgrade} />;
  }

  return (
    <>
      <QualifiesForUpdateMessage
        variants={variants}
        selectVariant={selectVariant}
      />
      <BaseProductMessage
        sku={selectedVariant?.product?.sku}
        customerEmail={customerEmail}
      />
    </>
  );
};

export default AuthenticatedUserUpgradeMessage;
